export function handleSearchFocus() {
    const input = document.querySelector('[data-search-query]');
    if (!input)
        return;
    input.addEventListener('focus', () => {
        const pos = input.value.length;
        input.setSelectionRange(pos, pos);
    });
}
